/** @jsxRuntime automatic */
/** @jsxImportSource @fluentui/react-jsx-runtime */

import { assertSlots } from '@fluentui/react-components';
import type { JSXElement } from '@fluentui/react-utilities';
import type { ChatInputTokenState, ChatInputTokenSlots } from './ChatInputToken.types';

/**
 * Render the final JSX of ChatInputToken
 */
export const renderChatInputToken_unstable = (state: ChatInputTokenState): JSXElement => {
  assertSlots<ChatInputTokenSlots>(state);

  return <state.root />;
};
